import React, { useMemo } from 'react'

import { useDashboardFeatureFlags } from '@components'
import { Select } from '@fourthwall/components'

import { useReportType } from '../../../../hooks/useReportType'
import type { AnalyticsParams } from '../../AnalyticsParams.types'
import { useAnalyticsParams } from '../../hooks/useAnalyticsParams'
import * as S from './ChartEntityGroupSelect.styled'

export const ChartEntityGroupSelect = () => {
  const { reportType } = useReportType()
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()
  const {
    queryParams: {
      chartEntity: [chartEntityGroupParam, setChartEntityGroupParam],
    },
  } = useAnalyticsParams()

  const options = useMemo(() => {
    const options = [
      { label: 'All', value: 'ALL' },
      { label: 'Orders', value: 'ORDERS' },
      { label: 'Donations', value: 'DONATIONS' },
      { label: 'Twitch Gifts', value: 'GIVEAWAY' },
      { label: 'Giveaway links', value: 'GIFTS_ON_CREATOR_COST' },
    ]

    if (dashboardFeatureFlags.memberships.enabled) {
      options.push(
        { label: 'Memberships', value: 'SUBSCRIPTIONS' },
        { label: 'Memberships tip', value: 'MEMBERSHIP_TIP' },
      )
    }
    if (dashboardFeatureFlags.memberships.enabled) {
      options.push({ label: 'Memberships locked message', value: 'MEMBERSHIP_LOCKED_MESSAGE' })
    }

    return options
  }, [dashboardFeatureFlags.memberships.enabled])

  if (reportType !== 'orders' && reportType !== 'profit') return null

  return (
    <S.Container>
      <Select
        label="Type"
        options={options}
        size="medium"
        value={
          Array.isArray(chartEntityGroupParam)
            ? chartEntityGroupParam[0] || options[0].value
            : chartEntityGroupParam || options[0].value
        }
        onValueChange={(value) =>
          setChartEntityGroupParam([value] as AnalyticsParams['chartEntityGroup'])
        }
      />
    </S.Container>
  )
}
